import React, { useState } from 'react';
import { Navbar, Nav, Image, Alert, Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import fb from './img/icons8-facebook-48.png'
import ig from './img/icons8-instagram-48.png'

const Menu = () => {
  const [show, setShow] = useState(true);
  const [expanded, setExpanded] = useState(false);

  return (
    <div>
      <Navbar expand="lg" expanded={expanded} className="bg-body-tertiary shadow-sm p-2 mb-2 rounded" bg="primary" data-bs-theme="dark">
        <Container className='position-relative'>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" onClick={() => setExpanded(!expanded)}/>
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav fill onClick={() => setExpanded(false)}>
              <Nav.Link as={Link} to="/" className="link">Acceuil</Nav.Link>
              <Nav.Link as={Link} to="/nos-males" className="link">Nos mâles</Nav.Link>
              <Nav.Link as={Link} to="/nos-femelles" className="link">Nos femelles</Nav.Link>
              <Nav.Link as={Link} to="/devenir-famille" className="link">Devenez famille d'élevage</Nav.Link>
              <Nav.Link as={Link} to="/carnet-de-naissances" className="link">Carnet de naissances</Nav.Link>
              <Nav.Link as={Link} to="/contact" className="link">Contact</Nav.Link>
            </Nav>
          </Navbar.Collapse>
          <Nav className="justify-content-center flex-row d-flex ms-auto" onClick={() => setExpanded(false)}>
            <Nav.Link as={Link} to="https://www.facebook.com/people/%C3%89levage-des-Bruy%C3%A8res-de-Servi%C3%A8re/100057480758331/">
              <Image src={fb} roundedCircle/>
            </Nav.Link>
            <Nav.Link as={Link} to="https://www.instagram.com/les_bruyeres_de_serviere/" style={{marginLeft: 10}}>
              <Image src={ig} roundedCircle/>
            </Nav.Link>
          </Nav>
        </Container>
      </Navbar>
      <div className='container'>
        <h5 className='d-flex justify-content-center'>
          <Alert show={show} dismissible onClose={() => setShow(false)} variant="info">
            Portées de <Alert.Link as={Link} to='/nos-femelles' state={{name:'Speyburn'}}>Speyburn</Alert.Link> et <Alert.Link as={Link} to='/nos-femelles' state={{name:'Usher'}}>Usher</Alert.Link> disponibles.
            N'hésitez pas à <Alert.Link as={Link} to='/Contact'>nous contacter</Alert.Link> pour plus d'informations.
          </Alert>
          {!show && <Alert onClick={() => setShow(true)} variant='info'>Informations portées</Alert>}
        </h5>
      </div>
    </div>
  );
}

export default Menu;
